import React, { useEffect, useMemo, useState,useContext } from "react";
import { Container, Form, Modal, Table } from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { isEmpty } from "lodash";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import AuthContext from "../context/AuthContext";
import helpers from "../utils/helpers";

const BetListLiveModal = ({ onClose, object }) => {
    let { user } = useContext(AuthContext);

  const [data, setData] = useState({});
  const [jsonData, setJsonData] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");

  const getData = async (object) => {
    try {
      const queryParams = new URLSearchParams({
        marketId: object?.marketId,
        eventId: object?.eventId,
        timeInserted: object?.timeInserted,
      }).toString();


      const response = await fetch(
        `https://napi247.com:5018${apiPath.getBetsliveOdds}?${queryParams}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const response_users = await response.json();

      if (response.status === 200) {
        if (response_users.success) {
          setJsonData(response_users?.results?.match?.jsonData);
          setSelectedTeam(
            response_users?.results?.match?.jsonData[0]?.RunnerName,
          );
          setData(response_users?.results);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (!isEmpty(object)) {
      getData(object);
    }
  }, [object]);

  // function getTeamTableData(formattedOdds, teamName) {
  //   if (!teamName) return [];

  //   const rows = [];

  //   for (const log of formattedOdds) {
  //     const runner = log.runners.find((r) => r.runnerName === teamName);

  //     if (!runner) continue;

  //     rows.push({
  //       time: moment(log.timestamp).format("DD/MM/YYYY HH:MM:SS"), // HH:mm:ss
  //       back: runner.backOdds,
  //       lay: runner.layOdds,
  //     });
  //   }

  //   return rows;
  // }

  function formatOddsASC(match, odds) {
    // Build runner lookup once (O(n))
    if (!isEmpty(match)) {
      const runnerMap = Object.create(null);
      for (const r of match.jsonData) {
        runnerMap[r.SelectionId] = r.RunnerName;
      }

      // Collect all logs from all odds docs
      const logs = [];
      for (const o of odds) {
        if (o?.dataLog?.length) {
          logs.push(...o.dataLog);
        }
      }

      // Sort ASC using timestamp string (ISO-safe & faster)
      logs.sort((a, b) => a.timestamp.localeCompare(b.timestamp));

      // Map to final structure
      return logs.map((log) => ({
        timestamp: log.timestamp,
        runners: log.runners.map((runner) => ({
          selectionId: +runner.selectionId,
          runnerName: runnerMap[runner.selectionId] ?? "Unknown",
          backOdds: runner.backOdds,
          layOdds: runner.layOdds,
        })),
      }));
    }
  }

  let formattedOdds = useMemo(
    () => formatOddsASC(data?.match, data?.odds),
    [data?.match, data?.odds],
  );

  return (
    <Modal size="2xl" show={true} onHide={onClose}>
      <Modal.Body>
        <section style={{ position: "relative" }}>
          <RxCross2
            size={20}
            onClick={() => onClose()}
            style={{ position: "absolute", right: "0%" }}
          />

          <Container fluid>
            <div
              style={{ fontSize: "14px", marginBottom: "10px" }}
              className="match-point p-2 pb-0"
            >
              <span className="master-pass">{object?.matchName}</span>
              <span
                style={{ marginLeft: "4px", fontWeight: "700" }}
                className="master-pass"
              >
                - Match Odds
              </span>
            </div>
            <Table className="border">
              <thead>
                <tr>
                  <th className="text-center">Time</th>
                  {jsonData?.map((res) => {
                    return <th className="text-center">{res?.RunnerName}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {formattedOdds?.length > 0 ? (
                  formattedOdds?.map((res) => {
                    return (
                      <tr>
                        <td className="text-center" style={{ width: "20%" }}>
                          {/* {moment(res?.timestamp).format("DD/MM/YYYY hh:mm:ss")} */}
                         { helpers.dateFormat(res?.timestamp, user.timeZone)}
                        </td>
                        {res?.runners?.map((item) => {
                          let back =
                            item?.backOdds?.length > 0 ? item?.backOdds[0] : {};
                          let lay =
                            item?.layOdds?.length > 0 ? item?.layOdds[0] : {};
                          return (
                            <td
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    border: "1px solid grey",
                                    background: "#72bbef",
                                    padding: "5px",
                                    width: "30%",
                                  }}
                                >
                                  <div className="fw-normal text-center bet-name back rounded-0 p-1">
                                    <strong className="d-block">
                                      {back?.price}
                                    </strong>
                                    {back?.size}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    border: "1px solid grey",
                                    background: "#faa9ba",
                                    padding: "5px",
                                    width: "30%",
                                  }}
                                >
                                  <div className="fw-normal text-center bet-name lay rounded-0 p-1">
                                    <strong className="d-block">
                                      {lay?.price}
                                    </strong>
                                    {lay?.size}
                                  </div>
                                </div>
                              </div>
                            </td>
                          );
                        })}

                        {/* <td className="text-center" style={{ width: "30%" }}>
                          {" "}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              justifyContent: "center",
                            }}
                          >
                            {res?.back?.map((item) => {
                              return (
                                <div
                                  style={{
                                    border: "1px solid grey",
                                    background: "#72bbef",
                                    padding: "5px",
                                    width: "30%",
                                  }}
                                >
                                  <div className="fw-normal text-center bet-name lay rounded-0 p-1">
                                    <strong className="d-block">
                                      {item?.price}
                                    </strong>
                                    {item?.size}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </td>
                        <td className="text-center " style={{ width: "30%" }}>
                          {" "}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              justifyContent: "center",
                            }}
                          >
                            {res?.lay?.map((item) => {
                              return (
                                <div
                                  style={{
                                    border: "1px solid grey",
                                    background: "#faa9ba",
                                    padding: "5px",
                                    width: "30%",
                                  }}
                                >
                                  <div className="fw-normal text-center bet-name lay rounded-0 p-1">
                                    <strong className="d-block">
                                      {item?.price}
                                    </strong>
                                    {item?.size}
                                  </div>
                                </div>
                              );
                            })}{" "}
                          </div>
                        </td> */}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={3}>No Data!</td>
                  </tr>
                )}
              </tbody>
            </Table>
            {/* <Table className="border">
              <thead>
                <tr>
                  <th className="text-center">Time</th>
                  <th className="text-center">Back</th>
                  <th className="text-center">Lay</th>
                </tr>
              </thead>
              <tbody>
                {tableData?.length > 0 ? (
                  tableData?.map((res) => {
                    return (
                      <tr>
                        <td className="text-center" style={{ width: "20%" }}>
                          {res?.time}
                        </td>
                        <td className="text-center" style={{ width: "30%" }}>
                          {" "}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              justifyContent: "center",
                            }}
                          >
                            {res?.back?.map((item) => {
                              return (
                                <div
                                  style={{
                                    border: "1px solid grey",
                                    background: "#72bbef",
                                    padding: "5px",
                                    width: "30%",
                                  }}
                                >
                                  <div className="fw-normal text-center bet-name lay rounded-0 p-1">
                                    <strong className="d-block">
                                      {item?.price}
                                    </strong>
                                    {item?.size}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </td>
                        <td className="text-center " style={{ width: "30%" }}>
                          {" "}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              justifyContent: "center",
                            }}
                          >
                            {res?.lay?.map((item) => {
                              return (
                                <div
                                  style={{
                                    border: "1px solid grey",
                                    background: "#faa9ba",
                                    padding: "5px",
                                    width: "30%",
                                  }}
                                >
                                  <div className="fw-normal text-center bet-name lay rounded-0 p-1">
                                    <strong className="d-block">
                                      {item?.price}
                                    </strong>
                                    {item?.size}
                                  </div>
                                </div>
                              );
                            })}{" "}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={3}>No Data!</td>
                  </tr>
                )}
              </tbody>
            </Table> */}
          </Container>
        </section>
      </Modal.Body>
    </Modal>
  );
};

export default BetListLiveModal;
